import {
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Input,
  rem,
  Select,
  Text,
  Tooltip,
} from "@mantine/core";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";

import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import {
  useDebouncedCallback,
  useDisclosure,
  useHotkeys,
  useIsFirstRender,
} from "@mantine/hooks";
import {
  IconBarcode,
  IconCoin,
  IconDiscount,
  IconFileExport,
  IconMapPin,
  IconMoneybag,
  IconPhone,
  IconSearch,
  IconTimeDuration15,
  IconUsers,
} from "@tabler/icons-react";
import { addMonths } from "date-fns";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import {
  keySearchReportSaleOrder,
  repositoryPos,
} from "../../../../_base/_const/_constVar";
import BreadcrumbLayout1 from "../../../../_base/component/_layout/_breadcrumb";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../../common/FormatDate/FormatDate";
import LoadingOverlayCustom from "../../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { BASE_API_POS } from "../../../../config";
import { _localization } from "../../../../config/location";
import { green } from "../../../../const/variables";
import { MessageResponse } from "../../../../model/MessageResponse";
import { SelectListItemModel } from "../../../../model/SelectListItem";
import { reportItemSales } from "../../../../model/TblOrderHeader";
const ReportSaleOrder = () => {
  const navigate = useNavigate();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<reportItemSales[]>([]);
  const [dataSum, setDataSum] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [visible, { toggle, close, open }] = useDisclosure(false);

  //Lấy userLoginHeader trong localStorage
  const userLoginHeader = JSON.parse(
    localStorage.getItem("userLoginHeader") || "{}"
  );
  //Bộ phận
  const [dataDepartment, setDataDepartment] = useState<SelectListItemModel[]>(
    []
  );
  //Đối tượng công nợ
  const [dataTblDebtGroup, setDataTblDebtGroup] = useState<
    SelectListItemModel[]
  >([]);

  //chi nhánh
  const [dataBranchCode, setDataBranchCode] = useState<SelectListItemModel[]>(
    []
  );
  const sizeGrid = { base: 6, sm: 3, md: 3, lg: 2, xl: 2 };

  // Nhân viên
  const [dataEmployee, setDataEmployee] = useState<SelectListItemModel[]>([]);

  const firstRender = useIsFirstRender();
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";
  const _searchJson = (() => {
    try {
      const storedValue = sessionStorage.getItem(keySearchReportSaleOrder);
      return storedValue ? JSON.parse(storedValue) : null;
    } catch (error) {
      console.error("Lỗi khi parse JSON từ sessionStorage:", error);
      return null;
    }
  })();
  const innitStateSearch = React.useMemo(
    () => ({
      keySearch:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.KeySearch
          : "",
      FromDate:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.FromDate
          : new Date(
              new Date(
                new Date().setMonth(new Date().getMonth() - 1)
              ).getTime() +
                7 * 60 * 60 * 1000
            )?.toISOString(),
      ToDate:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.ToDate
          : new Date(new Date().getTime() + 7 * 60 * 60 * 1000).toISOString(),
      BranchCode:
        firstRender &&
        _searchJson &&
        checkedPinSearch &&
        _searchJson.BranchCode !== ""
          ? _searchJson.BranchCode
          : "",
      DeparmentCode:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.DeparmentCode
          : "",
      TelephoneNumber:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.TelephoneNumber
          : "",
      OrderStatus:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.OrderStatus
          : "",
      IsGG:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.IsGG
          : null,
      IsCK:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.IsCK
          : null,
      IsNo:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.IsNo
          : null,
      MaDTCN:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.MaDTCN
          : "",
      MaNgDuyet:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.MaNgDuyet
          : "",
    }),
    [firstRender, _searchJson]
  );

  const formSeachInput = useForm({
    mode: "uncontrolled",
    // initialValues: {
    //   keySearch: "",
    //   FromDate: "",
    //   ToDate: "",
    //   BranchCode: "", //Mã chi nhánh
    //   DeparmentCode: "",
    //   TelephoneNumber: "", // Số điện thoại
    //   OrderStatus: "", // Trạng thái đơn hàng
    //   IsGG: null, // Có giảm giá
    //   IsCK: null, // Có chiết khấu
    //   IsNo: null, //Có nợ
    //   MaDTCN: "", //Mã đối tượng công nợ
    // },
    initialValues: innitStateSearch,
  });

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);

    // Tạo object keySearch
    const keySearch = {
      Skip: pagination?.pageIndex * pagination.pageSize,
      Take: pagination.pageSize,
      KeySearch: formSeachInput.getValues().keySearch || "",
      FromDate: formSeachInput.getValues().FromDate || "",
      ToDate: formSeachInput.getValues().ToDate || "",
      BranchCode: formSeachInput.getValues().BranchCode || "",
      DeparmentCode: formSeachInput.getValues().DeparmentCode || "",
      IsGG: formSeachInput.getValues().IsGG || "",
      IsCK: formSeachInput.getValues().IsCK || "",
      IsNo: formSeachInput.getValues().IsNo || "",
      TelephoneNumber: formSeachInput.getValues().TelephoneNumber || "",
      MaDTCN: formSeachInput.getValues().MaDTCN || "",
      MaNgDuyet: formSeachInput.getValues().MaNgDuyet || "",
    };

    try {
      // Tạo URL từ keySearch
      let url = `/api/v1/SaleByCustByOrder/get-list?`;
      Object.entries(keySearch).forEach(([key, value]) => {
        if (value) {
          url += `${key}=${encodeURIComponent(value)}&`;
        }
      });

      const response = await repositoryPos.get<MessageResponse<any>>(url);
      if (response && response.success) {
        const result = response.data;
        setData(result.lists);
        setDataSum({
          totalConNo: result?.totalConNo,
          totalTienBan: result?.totalTienBan,
          totalTienCk: result?.totalTienCk,
          totalTienGg: result?.totalTienGg,
          totalTienCkGg: result?.totalTienCkGg,
          totalTienDaTra: result?.totalTienDaTra,
          totalTienDonHang: result?.totalTienDonHang,
          totalTienVon: result?.totalTienVon,
        });
        setRowCount(response.totalCount);
      } else {
        setData([]);
        setDataSum({
          totalConNo: 0,
          totalTienBan: 0,
          totalTienCk: 0,
          totalTienGg: 0,
          totalTienCkGg: 0,
          totalTienDaTra: 0,
          totalTienDonHang: 0,
          totalTienVon: 0,
        });
        setRowCount(0);
        setIsLoading(false);
      }
    } catch (error) {
      setData([]);
      console.error("Error fetching data:", error);
    } finally {
      sessionStorage.setItem(
        keySearchReportSaleOrder,
        JSON.stringify(keySearch)
      );
      setIsLoading(false);
      setIsRefetching(false);
    }
  };
  const handleCheckView = async (row: any) => {
    if (row.original.soHd == "3") {
      const url = `/api/v1/CreateSellItem/details?orderNumber=${row.original.soHd}`;
      const response = await repositoryPos.get<MessageResponse<any>>(url);

      if (response && response.success) {
        navigate("/sell/view-return-order", {
          state: {
            id: row.original.orderId,
            orderNumber: row.original.soHd,
            actionType: "view",
          },
        });
      }
    } else {
      const url = `/api/v1/CreateSellItem/details?orderNumber=${row.original.soHd}`;
      const response = await repositoryPos.get<MessageResponse<any>>(url);

      if (response && response.success) {
        navigate("/sell/view-order", {
          state: {
            id: row.original.orderId,
            orderNumber: row.original.soHd,
            actionType: "view",
          },
        });
      }
    }
  };

  useEffect(() => {
    const handleCheckView = async () => {};
    handleCheckView();
  }, []);

  const columns = React.useMemo<MRT_ColumnDef<reportItemSales>[]>(
    () => [
      // Nhóm 3: Thông tin hợp đồng
      {
        accessorKey: "soHd",
        header: "Số hợp đồng",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              variant="dot"
              radius="xs"
              onDoubleClick={() => handleCheckView(row)}
              style={{
                cursor: "pointer",
              }}
              size="lg"
              color={renderedCellValue === null ? "red" : green.base}
            >
              {renderedCellValue}
            </Badge>
          </Tooltip>
        ),
      },
      {
        accessorKey: "trangThaiDon",
        header: "Trạng thái đơn",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      // Nhóm 1: Thông tin tài chính
      {
        accessorKey: "conNo",
        header: "Còn nợ",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
        Footer: ({ table }: any) => {
          return (
            <div>
              <Text ta="right" c="red" fw={800}>
                {formatCurrencyVND(dataSum.totalConNo)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "tienBan",
        header: "Tổng sau CK/GG",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
        Footer: ({ table }: any) => {
          return (
            <div>
              <Text ta="right" c="red" fw={800}>
                {formatCurrencyVND(dataSum.totalTienBan)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "tienCk",
        header: "Tiền chiết khấu",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
        Footer: ({ table }: any) => {
          return (
            <div>
              <Text ta="right" c="red" fw={800}>
                {formatCurrencyVND(dataSum.totalTienCk)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "tienGg",
        header: "Tiền giảm giá",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
        Footer: ({ table }: any) => {
          return (
            <div>
              <Text ta="right" c="red" fw={800}>
                {formatCurrencyVND(dataSum.totalTienGg)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "tienCkGg",
        header: "Tổng CK/GG",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
        Footer: ({ table }: any) => {
          return (
            <div>
              <Text ta="right" c="red" fw={800}>
                {formatCurrencyVND(dataSum.totalTienCkGg)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "tienDaTra",
        header: "Tiền đã trả",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
        Footer: ({ table }: any) => {
          return (
            <div>
              <Text ta="right" c="red" fw={800}>
                {formatCurrencyVND(dataSum.totalTienDaTra)}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "tienDonHang",
        header: "Tiền đơn hàng",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
        Footer: ({ table }: any) => {
          return (
            <div>
              <Text ta="right" c="red" fw={800}>
                {formatCurrencyVND(dataSum.totalTienDonHang)}
              </Text>
            </div>
          );
        },
      },

      {
        accessorKey: "tienVon",
        header: "Tiền vốn",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
        Footer: ({ table }: any) => {
          return (
            <div>
              <Text ta="right" c="red" fw={800}>
                {formatCurrencyVND(dataSum.totalTienVon)}
              </Text>
            </div>
          );
        },
      },

      // Nhóm 2: Thông tin khách hàng
      {
        accessorKey: "maKh",
        header: "Mã khách hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "tenKh",
        header: "Tên khách hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "telephoneNumber",
        header: "Số điện thoại",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },

      // Nhóm 4: Thông tin phòng ban, chi nhánh
      {
        accessorKey: "nguoiHuongSo",
        header: "Người hưởng số",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "nvKd",
        header: "Nhân viên kinh doanh",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "deparmentCode",
        header: "Mã phòng ban",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "deparmentName",
        header: "Tên phòng ban",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "maCn",
        header: "Mã chi nhánh",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "maDtcn",
        header: "Mã đối tượng CN",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "maNguoiDuyet",
        header: "Mã người duyệt",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "tenNguoiDuyet",
        header: "Tên người duyệt",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },

      // Nhóm 5: Thông tin khác
      {
        accessorKey: "ngayTao",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "ngayHoanThanh",
        header: "Ngày hoàn thành",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
    ],
    [dataSum]
  );

  const table = useMantineReactTable({
    columns,
    data: data || [],
    enableColumnResizing: true,
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,

    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["SoHd"],
        // right: ["tTienDh", "action"],
      },
      columnVisibility: { id: true },
      density: "xs",
    },
    enableRowSelection: false,
    mantineTableContainerProps: {
      style: { maxHeight: height - 100, minHeight: height - 100 },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    enableColumnFilters: true,
    enableSorting: true,
    enableStickyFooter: true,
    enableColumnActions: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    onColumnFiltersChange: setColumnFilters,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "550",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      rowSelection,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  // // Lấy danh sách mã chi nhánh
  // const DataBranchCode = async () => {
  //   try {
  //     const response = await repositoryDelivery.get(
  //       `api/v1/TblDmMasterOrg/get-select`
  //     );

  //     if (response && response.success) {
  //       const transformedData = response.data.map((item: any) => ({
  //         value: item.value,
  //         label: item.value + " - " + item.text,
  //       }));
  //       setDataBranchCode(transformedData);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     return;
  //   }
  // };

  // Lấy danh sách mã bộ phận
  const fetchDataBp = async () => {
    try {
      // if (
      //   userLogin &&
      //   userLogin.branchId !== null &&
      //   userLogin.branchId !== undefined
      // ) {
      //   const response = await repositoryPos.get(
      //     `/api/v1/TblDepartment/get-all?branchId=${userLogin?.branchId}`
      //   );
      //   if (response && response.success) {
      //     const transformedData = response.data.map((item: any) => ({
      //       value: String(item.deparmentCode),
      //       label: item.deparmentCode + " - " + item.name,
      //     }));
      //     setDataDepartment(transformedData);
      //   } else {
      //     setDataDepartment([]);
      //   }
      // } else {
      const response = await repositoryPos.get(`/api/v1/TblDepartment/get-all`);
      if (response && response.success) {
        const seen = new Set(); //dùng set để xử lý bị trùng daparmentCode
        const transformedData = response.data
          .filter(
            (i: any) =>
              i.deparmentCode !== null &&
              i.name !== null &&
              !seen.has(i.deparmentCode) &&
              seen.add(i.deparmentCode)
          )
          .map((item: any) => ({
            value: String(item.deparmentCode),
            label: item.deparmentCode + " - " + item.name,
          }));
        setDataDepartment(transformedData);
      } else {
        setDataDepartment([]);
      }
      // }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  const DataBranchCode = async () => {
    try {
      const response = await repositoryPos.get(
        `api/v1/TblDmInventory/get-select-branch?auth=true`
      );
      if (response && response.success && response.data) {
        const transformedData = response.data
          .filter(
            (branch: any) => branch.att2 !== null && branch.text !== "Tất cả"
          )
          .map((branch: any) => ({
            value: branch.att2,
            label: branch.att2 + " - " + branch.text,
          }));
        setDataBranchCode(transformedData);
        // Kiểm tra nếu BranchCode chưa được thiết lập
        const currentBranchCode = formSeachInput.getValues().BranchCode;
        if (!currentBranchCode) {
          // Tìm `att2` tương ứng với `branchId` từ localStorage
          const branchId = userLoginHeader?.branchId?.toString();
          const matchedBranch = response?.data.find(
            (item: any) => item.value.toString() === branchId.toString()
          );
          if (matchedBranch) {
            formSeachInput.setFieldValue(
              "BranchCode",
              matchedBranch.att2.toString()
            );
          }
        }
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  const fetchDataDebt = async (value?: string) => {
    let url;
    if (!value) {
      url = `/api/v1/TblDebtGroup/get-list?Skip=0&Take=50`;
    } else {
      url = `/api/v1/TblDebtGroup/get-list?Skip=0&Take=50&KeySearch=${value}`;
    }

    try {
      const response = await repositoryPos.get<MessageResponse<any[]>>(url);
      if (response?.success && response?.data) {
        const data = response.data;

        const mappedData = Array.from(
          new Map(
            data.map((value) => [
              value?.groupCode,
              {
                value: value?.groupCode?.toString(),
                label: `${value?.groupCode?.toString()} - ${value?.groupName}`,
              },
            ])
          ).values()
        );
        setDataTblDebtGroup(mappedData);
      }
    } catch (error) {
      setDataTblDebtGroup([]);
      console.error("Error fetching data:", error);
    }
  };

  //Lấy list nhân viên
  const fetchSelectEmployee = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmEmployee/get-select"
    );
    if (dataApi && dataApi.success) {
      const filteredData = dataApi.data
        .filter((item: any) => item.value !== null && item.text !== null)
        .map((i: any) => ({
          value: i.att1,
          label: ` ${i.att1} - ${i.text}`,
        }));
      setDataEmployee(filteredData);
    }
  };
  // Sử dụng debounce để trì hoãn việc gọi API
  const debouncedDataItemCode = useDebouncedCallback((value: string) => {
    if (value.length >= 3) {
      fetchDataDebt(value); // Gọi API với từ khóa tìm kiếm
    }
  }, 500);

  // Lưu key search
  // useEffect(() => {
  //   const runAsyncFunctions = async () => {
  //     await SaveKeySearch(formSeachInput, null, 1);

  //     // localStorage.removeItem("allValueKeySearch");
  //   };
  //   const nextuse = async () => {
  //     await Promise.all([fetchDataBp(), DataBranchCode(), fetchDataDebt()]);
  //     await runAsyncFunctions();
  //     await fetchData();
  //   };
  //   nextuse();
  // }, []);
  useEffect(() => {
    const runAsyncFunctions = async () => {
      await Promise.all([
        fetchDataBp(),
        DataBranchCode(),
        fetchDataDebt(),
        fetchSelectEmployee(),
      ]);
    };
    const nextuse = async () => {
      await runAsyncFunctions();
      await fetchData();
    };
    nextuse();
  }, []);

  useEffect(() => {
    fetchData();
  }, [pagination]);

  const formatCurrencyVND = (value: any) => {
    if (value == null) {
      return "";
    }
    // Định dạng số theo chuẩn Việt Nam
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0, // Không hiển thị phần thập phân
      maximumFractionDigits: 0, // Đảm bảo không có chữ số sau dấu phẩy
    });
  };

  const exportDataExcel = async () => {
    open(); // Hiển thị loading
    // Khởi tạo URL với các tham số phân trang
    let queryParams = `Skip=${
      pagination?.pageIndex * pagination.pageSize
    }&Take=${pagination.pageSize}`;

    // Thêm các tham số tìm kiếm nếu có
    if (formSeachInput.getValues().keySearch) {
      queryParams += `&KeySearch=${formSeachInput.getValues().keySearch}`;
    }
    if (formSeachInput.getValues().FromDate) {
      queryParams += `&FromDate=${formatDateNotTimeZone(
        formSeachInput.getValues().FromDate
      )}`;
    }
    if (formSeachInput.getValues().ToDate) {
      queryParams += `&ToDate=${formatDateNotTimeZone(
        formSeachInput.getValues().ToDate
      )}`;
    }
    if (formSeachInput.getValues().BranchCode) {
      queryParams += `&BranchCode=${formSeachInput.getValues().BranchCode}`;
    }
    if (formSeachInput.getValues().DeparmentCode) {
      queryParams += `&DeparmentCode=${
        formSeachInput.getValues().DeparmentCode
      }`;
    }
    if (formSeachInput.getValues().IsGG) {
      const isValue = formSeachInput.getValues().IsGG === "true";
      queryParams += `&IsGG=${isValue}`;
    }
    if (formSeachInput.getValues().IsCK) {
      const isValue = formSeachInput.getValues().IsCK === "true";
      queryParams += `&IsCK=${isValue}`;
    }
    if (formSeachInput.getValues().IsNo) {
      const isValue = formSeachInput.getValues().IsNo === "true";
      queryParams += `&IsNo=${isValue}`;
    }
    if (formSeachInput.getValues().TelephoneNumber) {
      queryParams += `&TelephoneNumber=${
        formSeachInput.getValues().TelephoneNumber
      }`;
    }
    if (formSeachInput.getValues().MaDTCN) {
      queryParams += `&MaDTCN=${formSeachInput.getValues().MaDTCN}`;
    }
    if (formSeachInput.getValues().MaDTCN) {
      queryParams += `&MaNgDuyet=${formSeachInput.getValues().MaNgDuyet}`;
    }

    // Xây dựng URL API cuối cùng
    const fullUrl = `${BASE_API_POS}/api/v1/SaleByCustByOrder/export-excel?${queryParams}`;
    const token = localStorage.getItem("token");

    try {
      const response = await fetch(fullUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token?.replace(/"/g, "")}`,
          "Content-Type": "application/vnd.ms-excel",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch the resource");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const filename = "bao_cao_doanh_so_ban_hang.xlsx"; // Tên mặc định nếu không có header
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      close(); // Đóng loading
    }
  };
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (200 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  useHotkeys([
    [
      "enter",
      () => {
        fetchData();
        localStorage.setItem(
          "allValueKeySearch",
          JSON.stringify({
            ...formSeachInput.getValues(),
            url: String(window.location.pathname),
          })
        );
      },
    ],
  ]);

  return (
    <Box pos="relative">
      <LoadingOverlayCustom visible={visible} />
      <Flex
        justify="space-between"
        align="center"
        style={{
          border: "1px solid #dee2e6",
          padding: "5px 10px",
        }}
      >
        <BreadcrumbLayout1></BreadcrumbLayout1>
        <Button
          leftSection={
            <IconFileExport style={{ width: rem(14), height: rem(14) }} />
          }
          onClick={() => exportDataExcel()}
        >
          Export Excel
        </Button>
      </Flex>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
          // marginTop: "10px",
        }}
      >
        <Grid style={{ width: "100%" }} mt={10}>
          <Grid.Col span={sizeGrid}>
            <Input
              size="sm"
              placeholder="Từ khoá"
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              key={formSeachInput.key("keySearch")}
              {...formSeachInput.getInputProps("keySearch")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  fetchData();
                  // localStorage.setItem(
                  //   "allValueKeySearch",
                  //   JSON.stringify({
                  //     ...formSeachInput.getValues(),
                  //     url: String(window.location.pathname),
                  //   })
                  // );
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              // onChange={(date) => {
              //   formSeachInput.setFieldValue(
              //     "FromDate",
              //     formatDateNotTimeZone(date) || ""
              //   );
              // }}
              key={formSeachInput.key("FromDate")}
              {...formSeachInput.getInputProps("FromDate")}
              value={
                formSeachInput.getValues().FromDate
                  ? dayjs(formSeachInput.getValues().FromDate).toDate()
                  : null
              }
              onChange={(date) =>
                formSeachInput.setFieldValue(
                  "FromDate",
                  date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") : ""
                )
              }
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              // maxDate={new Date(formSeachInput.getValues().FromDate)}
              maxDate={
                formSeachInput.getValues().FromDate
                  ? addMonths(new Date(formSeachInput.getValues().FromDate), 1)
                  : undefined
              }
              // onChange={(date) => {
              //   formSeachInput.setFieldValue(
              //     "ToDate",
              //     formatDateNotTimeZone(date) || ""
              //   );
              // }}
              key={formSeachInput.key("ToDate")}
              {...formSeachInput.getInputProps("ToDate")}
              value={
                formSeachInput.getValues().ToDate
                  ? dayjs(formSeachInput.getValues().ToDate).toDate()
                  : null
              }
              onChange={(date) =>
                formSeachInput.setFieldValue(
                  "ToDate",
                  date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") : ""
                )
              }
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Chi nhánh"
              searchable
              clearable
              data={dataBranchCode}
              leftSection={<IconMapPin size={20} color="#15aabf" />}
              // key={formSeachInput.key("BranchCode")}
              // {...formSeachInput.getInputProps("BranchCode")}
              value={
                dataBranchCode.length > 0
                  ? formSeachInput.getValues().BranchCode
                  : ""
              }
              onChange={(e, value) => {
                formSeachInput.setFieldValue(
                  "BranchCode",
                  e ? e.toString() : ""
                );
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Input
              size="sm"
              placeholder="Số điện thoại"
              type="text"
              leftSection={<IconPhone color="#15aabf" />}
              key={formSeachInput.key("TelephoneNumber")}
              {...formSeachInput.getInputProps("TelephoneNumber")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Mã đối tượng công nợ"
              type="text"
              clearable
              searchable
              data={dataTblDebtGroup}
              value={
                dataTblDebtGroup.length > 0
                  ? formSeachInput.getValues().MaDTCN
                  : ""
              }
              leftSection={<IconUsers color="#15aabf" />}
              // key={formSeachInput.key("MaDTCN")}
              // {...formSeachInput.getInputProps("MaDTCN")}
              onSearchChange={(value) => {
                debouncedDataItemCode(value);
              }}
              onChange={(e, value) => {
                formSeachInput.setFieldValue("MaDTCN", e ? e.toString() : "");
              }}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Giảm giá"
              clearable
              leftSection={<IconCoin size={20} color="#15aabf" />}
              data={[
                { value: "true", label: "Đơn có giảm giá" },
                {
                  value: "false",
                  label: "Đơn không có giảm giá",
                },
              ]}
              value={formSeachInput.getValues().IsGG || ""}
              // key={formSeachInput.key("IsGG")}
              // {...formSeachInput.getInputProps("IsGG")}
              onChange={(e, value) => {
                formSeachInput.setFieldValue("IsGG", e ? e.toString() : "");
              }}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Chiết khấu"
              clearable
              leftSection={<IconDiscount size={20} color="#15aabf" />}
              data={[
                { value: "true", label: "Đơn có chiết khấu" },
                {
                  value: "false",
                  label: "Đơn không có chiết khấu",
                },
              ]}
              value={formSeachInput.getValues().IsCK || ""}
              // key={formSeachInput.key("IsCK")}
              // {...formSeachInput.getInputProps("IsCK")}
              onChange={(e, value) => {
                formSeachInput.setFieldValue("IsCK", e ? e.toString() : "");
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Có nợ"
              clearable
              leftSection={<IconMoneybag size={20} color="#15aabf" />}
              data={[
                { value: "true", label: "Đơn có nợ" },
                {
                  value: "false",
                  label: "Đơn không có nợ",
                },
              ]}
              value={formSeachInput.getValues().IsNo || ""}
              // key={formSeachInput.key("IsNo")}
              // {...formSeachInput.getInputProps("IsNo")}
              onChange={(e, value) => {
                formSeachInput.setFieldValue("IsNo", e ? e.toString() : "");
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Vui lòng chọn bộ phận"
              searchable
              clearable
              leftSection={<IconUsers size={20} color="#15aabf" />}
              data={dataDepartment}
              value={
                dataDepartment.length > 0
                  ? formSeachInput.getValues().DeparmentCode
                  : ""
              }
              // key={formSeachInput.key("DeparmentCode")}
              // {...formSeachInput.getInputProps("DeparmentCode")}
              onChange={(e, value) => {
                formSeachInput.setFieldValue(
                  "DeparmentCode",
                  e ? e.toString() : ""
                );
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Mã người duyệt"
              clearable
              searchable
              data={dataEmployee}
              value={
                dataEmployee.length > 0
                  ? formSeachInput.getValues().MaNgDuyet
                  : ""
              }
              leftSection={<IconBarcode size={20} color="#15aabf" />}
              onChange={(e, value) => {
                formSeachInput.setFieldValue(
                  "MaNgDuyet",
                  e ? e.toString() : ""
                );
              }}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <Button
              type="submit"
              leftSection={<IconSearch size={20} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
                localStorage.setItem(
                  "allValueKeySearch",
                  JSON.stringify({
                    ...formSeachInput.getValues(),
                    url: String(window.location.pathname),
                  })
                );
              }}
            >
              Tìm kiếm
            </Button>{" "}
          </Grid.Col>
        </Grid>
      </Box>

      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </Box>
  );
};

export default ReportSaleOrder;
